var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInvoiceGeneric = function SvgInvoiceGeneric(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m3.825 1.707.925.793 1.425-1.221a.5.5 0 0 1 .651 0L8.25 2.5l1.425-1.221a.5.5 0 0 1 .651 0L11.75 2.5l1.425-1.221a.5.5 0 0 1 .651 0L15.25 2.5l.925-.793a.5.5 0 0 1 .825.38v5.1l.631.513c.233.19.369.475.369.776V18a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.476c0-.301.136-.586.369-.776L3 7.188v-5.1a.5.5 0 0 1 .825-.381zM5 4.92v4.608L10 12l5-2.472V4.92l-1.5-1.286-1.75 1.5-1.75-1.5-1.75 1.5-1.75-1.5L5 4.92z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgInvoiceGeneric;